import type {
  ICampaignTargetCustom,
  ICustomCampaignTargetRule,
} from "@shared/common/custom-target-condition/types";

export const makeshopUserLogin: ICustomCampaignTargetRule = {
  key: "MAKESHOP_USER_LOGIN",

  checkValidRule({ siteType }) {
    return siteType === "MAKESHOP";
  },

  getDefaultValue() {
    return {
      type: "CUSTOM",
      key: "MAKESHOP_USER_LOGIN",
      value: "EVERYONE",
    };
  },

  getShortLabel(target: ICampaignTargetCustom) {
    switch (target.value) {
      case "EVERYONE":
        return "모든 유저";
      case "NO_LOGIN":
        return "미로그인 유저만";
      case "LOGIN":
        return "로그인 유저만";
      default:
        return null;
    }
  },

  checkPage(condition, { html }) {
    if (condition.key !== "MAKESHOP_USER_LOGIN") {
      return false;
    }

    if (condition.value === "EVERYONE") {
      return true;
    }

    /**
     * 테스트용 샘플
     *
     * 미로그인
     *  var IS_LOGIN = 'true';
     *
     * 로그인
     *  var IS_LOGIN = 'false';
     */

    const isLogin = html.innerHTML.includes("var IS_LOGIN = 'true'");
    // makeshop은 로그인 성공시 문자열로 true값을 가짐

    switch (condition.value) {
      case "NO_LOGIN":
        return !isLogin;
      case "LOGIN":
        return isLogin;
    }
  },
};

export default makeshopUserLogin;
